'use client';

import { Button } from '@packages/shared/src/ui/Button/Button';
import { useCallback, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useActiveSlide } from '../ImageGalleryProvider/ImageGalleryProvider.client';

export const ImageGalleryControls = ({ totalSlides }: { totalSlides: number }) => {
  const [currentSlide, setCurrentSlide] = useActiveSlide();
  const currentSlideRef = useRef(currentSlide);
  const { formatMessage } = useIntl();

  useEffect(() => {
    currentSlideRef.current = currentSlide;
  }, [currentSlide]);

  const scrollToSlide = useCallback(
    (index: number) => {
      const galleryScroll = document.getElementById('gallery-scroll');
      if (!galleryScroll) return;

      const slideWidth = galleryScroll.clientWidth;

      galleryScroll.scrollTo({
        left: slideWidth * index,
        behavior: 'smooth',
      });

      setCurrentSlide(index);
    },
    [setCurrentSlide],
  );

  const handlePrevious = () => {
    const newSlide = Math.max(0, currentSlideRef.current - 1);
    scrollToSlide(newSlide);
  };

  const handleNext = () => {
    const newSlide = Math.min(totalSlides - 1, currentSlideRef.current + 1);

    scrollToSlide(newSlide);
  };

  return (
    <>
      {currentSlide > 0 && (
        <Button
          variant="icon-flat"
          size="large"
          className="bg-color-carousel-dot absolute top-1/2 -left-2 z-10 hidden -translate-y-1/2 items-center justify-center rounded-full shadow-lg md:flex"
          onClick={handlePrevious}
          aria-label={formatMessage({
            id: 'imageGallery.aria.prevImage',
            defaultMessage: 'vorheriges Bild',
          })}
        >
          <span className="icon-emp-arrow-large-left" />
        </Button>
      )}

      {currentSlide < totalSlides - 1 && (
        <Button
          variant="icon-flat"
          size="large"
          className="bg-color-carousel-dot absolute top-1/2 -right-2 z-10 hidden -translate-y-1/2 items-center justify-center rounded-full shadow-lg md:flex"
          onClick={handleNext}
          aria-label={formatMessage({
            id: 'imageGallery.aria.nextImage',
            defaultMessage: 'nächstes Bild',
          })}
        >
          <span className="icon-emp-arrow-large-right" />
        </Button>
      )}
    </>
  );
};
